import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";


export default function Timer() {

    const [mes, setMes] = useState()
    const [dia, setDia] = useState()
    const [contador, setContador] = useState()
    const [color, setColor] = useState()
    const [fechas, setFechas] = useState([]);
    const hasFetched = useRef(false);

    useEffect(() => {
        if (hasFetched.current) return; 
        hasFetched.current = true;

        fetch("https://parrilla-backend.samidareno.com/fechas")
            .then((res) => res.json())
            .then((data) => {
                //setFechas(data);
                fechas.push(...data); 
                console.log(fechas);
                iniciarContador(); 
                return () => clearInterval(iniciarContador);
            })
            .catch((error) => console.error("Error al obtener fechas:", error));
    }, []);


    const obtenerProximaFecha = () => {
        const ahora = new Date();
        let proximaFecha = null;

        for (const fecha of fechas) {            
            const fechaObjetivo = new Date(fecha.fecha).getTime();
            //const fechaObjetivo = new Date(ahora.getFullYear(), fecha.getMonth() , fecha.getDay(), fecha.getHours(), fecha.getMinutes(), fecha.getSeconds()).getTime();
            //const fechaObjetivo = new Date(ahora.getFullYear(), fecha.mes - 1, fecha.dia, fecha.hora, fecha.minuto, fecha.segundo).getTime();

            if (fechaObjetivo > ahora.getTime()) {
                let mes="";
                let otro = new Date(fecha.fecha);
                switch(otro.getMonth() + 1  ){
                    case 1: mes="Enero"; break;
                    case 2: mes="Febrero"; break;
                    case 3: mes="Marzo"; break;
                    case 4: mes="Abril"; break;
                    case 5: mes="Mayo"; break;
                    case 6: mes="Junio"; break;
                    case 7: mes="Julio"; break;
                    case 8: mes="Agosto"; break;
                    case 9: mes="Setiembre"; break;
                    case 10: mes="Octubre"; break;
                    case 11: mes="Noviembre"; break;
                    case 12: mes="Diciembre"; break;
                }
    
                setMes(mes);
                setDia(otro.getDate());            
                return fechaObjetivo;
            }
           //return fechaObjetivo;

        }
        return proximaFecha;
    }

    const iniciarContador = () => {
        let fechaObjetivo = obtenerProximaFecha();
        if (!fechaObjetivo) {
            setContador("No hay más fechas programadas.");            
            return;
        }

        let intervalo = null;
        
        function actualizarContador() {
            const ahora = new Date().getTime();
            const diferencia = fechaObjetivo - ahora;

            if (diferencia <= 0) {
                setContador("¡Tiempo terminado!");                
                clearInterval(intervalo);

                setTimeout(() => {
                    iniciarContador();
                    setColor('rgb(92, 72, 167)');
                }, 5000);             

                return;
            }

            const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));
            const horas = Math.floor((diferencia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));
            const segundos = Math.floor((diferencia % (1000 * 60)) / 1000);
            
            if(dias <= 2){
                setColor('rgb(255, 0, 0)');
            }else if(dias <= 4){
                setColor('rgb(255, 165, 0)');
            }else if(dias <= 6){
                setColor('rgb(255, 255, 0)');                
            }else if(dias <= 30){
                setColor('rgb(0, 255, 0)');                 
            }
            setContador(dias + "d " + horas + "h " + minutos + "m " + segundos + "s ");
        }
        
        actualizarContador();
        intervalo = setInterval(actualizarContador, 1000);
    }

    return(
        <div>
            <h1>LA SIGUIENTE PARRILLADA SERA EN:</h1>
            <div id="Contador" style={{fontSize: 150, color:color}}>{contador}</div>
            <h2 id="Title-second">EL DIA SERA EL:</h2>
            <div id="Fecha" style={{fontSize: 100}}> {dia} de {mes}</div>
        </div>
    )

}
